import React from 'react';
import { Spinner, SpinnerSize } from "@fluentui/react";

export default function LoadingIcon({defaultHeight = false, spinnerSize = SpinnerSize.large}) {
  return (
    <div style={{overflow: 'hidden', height: defaultHeight ? 'auto' : '300px'}}><Spinner size={spinnerSize} styles={{root: { height: '100%' }}} /></div>
  )
}


// WEBPACK FOOTER //
// ./src/components/formFields/LoadingIcon.js